import React, { useContext } from "react";
import "./Subscriptions.scss";
import { Context } from "../Store";
import SliderSubscriptions from "./SliderSubscriptions";
import SubCard from "../custom-components/SubCard";
import SubAnnual from "../../imgs/SubAnnual.svg";
import subStore from "../../imgs/subStore.svg";
import subPos from "../../imgs/subPos.svg";
import subLink from "../../imgs/subLink.svg";
import supSupport from "../../imgs/supSupport.svg";

const Subscriptions = () => {
  const { dir, setIsClicked, variants4, siteInfoRes, packagesResData } =
    useContext(Context);

  const { title, subTitle } = packagesResData;
  return (
    <section id="subscriptions">
      <div className="container">
        <div className="head">
          <h2 className="sub-title">{title}</h2>
          <p className="sub-subtile">{subTitle}</p>
          <a target="_blank" href={siteInfoRes?.googlePlay}>
            <button>
              {dir === "ltr" ? "Start your free trial" : "ابدأ تجربتك المجانية"}
            </button>
          </a>
        </div>
        <div className="subscriptions-slider">
          <SliderSubscriptions />
        </div>
        <div className="sub-features">
          <h2 className="sub-title">
            {dir === "ltr"
              ? "Enjoy our various packages"
              : "استمتع بمميزات باقاتنا المتنوعة "}
          </h2>
          <p className="sub-subtile sub-subtile-feature ">
            {dir === "ltr"
              ? "myCASH application offers you many packages and subscriptions with various characteristics and advantages to suit your trade."
              : "يقدم لك تطبيق myCASH العديد من الباقات و الاشتراكات متنوعة الخصائص و المميزات لتتلاءم مع تجارتك."}
          </p>
          <div className="sub-features-cards">
            <SubCard
              imgScr={SubAnnual}
              cardTitle={dir === "ltr" ? "Annual Packages" : "باقات سنوية"}
              cardCap={
                dir === "ltr"
                  ? "Various and annual packages for your business, choose your package with us"
                  : "باقات متنوعة و سنوية لتجارتك، اختر باقتك معنا"
              }
            />
            <SubCard
              imgScr={subStore}
              cardTitle={
                dir === "ltr"
                  ? "Your online store with us"
                  : "متجرك اونلاين معنا "
              }
              cardCap={
                dir === "ltr"
                  ? "Start your online store and enjoy the ease of managing all your business with myCASH"
                  : "ابدأ متجرك الالكتروني و استمتع بسهولة إدارتك لكافة أعمالك مع myCASH"
              }
            />
            <SubCard
              imgScr={subPos}
              cardTitle={
                dir === "ltr"
                  ? "Application for your points of sale"
                  : "تطبيق لنقاط بيعك"
              }
              cardCap={
                dir === "ltr"
                  ? "Grow your business with the myCASH POS application for your products"
                  : "نمي تجارتك مع تطبيق  myCASH لنقاط بيع منتجاتك "
              }
            />
            <SubCard
              imgScr={subLink}
              cardTitle={
                dir === "ltr"
                  ? "Easy linkage with delivery companies"
                  : "ربط سهل مع شركات التوصيل"
              }
              cardCap={
                dir === "ltr"
                  ? "Enjoy an easy service in connecting your stores with reliable and distinguished delivery companies"
                  : "استمتع بخدمة سهلة في ربط متاجرك مع شركات توصيل موثوقة و مميزة"
              }
            />
            <SubCard
              imgScr={supSupport}
              cardTitle={
                dir === "ltr" ? "Technical support 24/7" : "دعم فني 24/7"
              }
              cardCap={
                dir === "ltr"
                  ? "We provide 24/7 technical support through email and instant chat"
                  : "نقدم لك دعم فني 24/7 من خلال البريد الإلكتروني والدردشة الفورية"
              }
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Subscriptions;
